import styles from '../../styles/Button.module.css';

const VARIANTS = new Set(['primary', 'secondary', 'tertiary', 'danger', 'outline']);

const Button = ({
  children,
  onClick,
  disabled,
  variant = 'primary',
  className = '',
  type = 'button',
  ...rest
}) => {
  const v = VARIANTS.has(variant) ? variant : 'primary';
  const classes = [styles.button, styles[v], className].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
